<div class="perfil-detalhe">
  <header class="perfil-detalhe__header">
    <app-back-button label="Voltar para perfis" data-testid="perfil-detalhe-voltar" (back)="voltar()" />
  </header>

  @if (isConfiguracoesMode) {
    <!-- Modo configurações gerais: todos os perfis -->
    <section aria-labelledby="perfil-detalhe-config-title">
      <h1
        id="perfil-detalhe-config-title"
        class="perfil-detalhe__title"
        data-testid="perfil-detalhe-config-title"
      >
        Configurações de perfis
      </h1>

      <div
        class="perfil-detalhe__filtro"
        role="group"
        aria-label="Filtrar por status"
        data-testid="perfil-detalhe-filtro"
      >
        @for (option of filtroOptions; track option.value) {
          <button
            type="button"
            class="perfil-detalhe__filtro-btn"
            [class.perfil-detalhe__filtro-btn--active]="filtroStatus() === option.value"
            [attr.aria-pressed]="filtroStatus() === option.value"
            [attr.data-testid]="'perfil-detalhe-filtro-' + option.value"
            (click)="setFiltroStatus(option.value)"
          >
            {{ option.label }}
          </button>
        }
      </div>

      @if (perfisFiltrados().length === 0) {
        <app-empty-state message="Nenhum perfil encontrado" data-testid="perfil-detalhe-config-vazio" />
      } @else {
        <ul class="perfil-detalhe__lista">
          @for (perfil of perfisFiltrados(); track perfil.id) {
            <li class="perfil-detalhe__lista-item" data-testid="perfil-detalhe-config-card">
              <div class="perfil-detalhe__lista-conteudo">
                <div class="perfil-detalhe__lista-header">
                  <div class="perfil-detalhe__title-row">
                    <h2 class="perfil-detalhe__card-title">{{ perfil.nome }}</h2>
                    <app-status-badge [status]="perfil.status" />
                  </div>

                  <div class="perfil-detalhe__lista-actions">
                    <button
                      type="button"
                      class="perfil-detalhe__btn-secondary perfil-detalhe__btn-secondary--sm"
                      (click)="editarPerfil(perfil.id)"
                    >
                      Editar Perfil
                    </button>
                  </div>
                </div>

                <dl class="perfil-detalhe__fields perfil-detalhe__fields--lista">
                  <div class="perfil-detalhe__field">
                    <dt class="perfil-detalhe__label">Nome de exibição</dt>
                    <dd class="perfil-detalhe__value">{{ perfil.nomeExibicao || '—' }}</dd>
                  </div>
                  <div class="perfil-detalhe__field">
                    <dt class="perfil-detalhe__label">Última atualização</dt>
                    <dd class="perfil-detalhe__value">{{ formatDate(perfil.ultimaAtualizacao) }}</dd>
                  </div>
                  <div class="perfil-detalhe__field perfil-detalhe__field--wide">
                    <dt class="perfil-detalhe__label">Descrição</dt>
                    <dd class="perfil-detalhe__value">{{ perfil.descricao || '—' }}</dd>
                  </div>
                </dl>

                @if (perfil.categorias.length > 0) {
                  <ul class="perfil-detalhe__categoria-list perfil-detalhe__categoria-list--inline">
                    @for (categoria of perfil.categorias; track $index) {
                      <li class="perfil-detalhe__categoria-item">
                        <span
                          class="perfil-detalhe__swatch"
                          aria-hidden="true"
                          [style.background-color]="categoria.cor"
                        ></span>
                        <span class="perfil-detalhe__categoria-nome">{{ categoria.nomeCategoria }}</span>
                        <span class="perfil-detalhe__categoria-valor">{{ categoria.valorPercentual }}%</span>
                      </li>
                    }
                  </ul>
                }
              </div>
            </li>
          }
        </ul>
      }
    </section>
  } @else if (naoEncontrado()) {
    <div class="perfil-detalhe__empty" role="alert" data-testid="perfil-detalhe-nao-encontrado">
      <p class="perfil-detalhe__empty-message">Perfil não encontrado.</p>
      <button type="button" class="btn-primary" (click)="voltar()">
        Voltar para perfis
      </button>
    </div>
  } @else if (perfil(); as perfil) {
    <!-- Modo visualização individual -->
    <section class="perfil-detalhe__card" aria-labelledby="perfil-detalhe-title">
      <div class="perfil-detalhe__title-row">
        <h1 id="perfil-detalhe-title" class="perfil-detalhe__title" data-testid="perfil-detalhe-title">
          {{ perfil.nome }}
        </h1>
        <app-status-badge [status]="perfil.status" data-testid="perfil-detalhe-status" />
      </div>

      <dl class="perfil-detalhe__fields">
        <div class="perfil-detalhe__field">
          <dt class="perfil-detalhe__label">Nome do perfil</dt>
          <dd class="perfil-detalhe__value">{{ perfil.nome }}</dd>
        </div>
        <div class="perfil-detalhe__field">
          <dt class="perfil-detalhe__label">Nome de exibição</dt>
          <dd class="perfil-detalhe__value">{{ perfil.nomeExibicao || '—' }}</dd>
        </div>
        <div class="perfil-detalhe__field">
          <dt class="perfil-detalhe__label">Status</dt>
          <dd class="perfil-detalhe__value">{{ perfil.status }}</dd>
        </div>
        <div class="perfil-detalhe__field">
          <dt class="perfil-detalhe__label">Última atualização</dt>
          <dd class="perfil-detalhe__value">{{ formatDate(perfil.ultimaAtualizacao) }}</dd>
        </div>
        <div class="perfil-detalhe__field perfil-detalhe__field--full">
          <dt class="perfil-detalhe__label">Descrição</dt>
          <dd class="perfil-detalhe__value">{{ perfil.descricao || '—' }}</dd>
        </div>
      </dl>

      <section class="perfil-detalhe__categorias" aria-labelledby="perfil-detalhe-categorias-title">
        <h2 id="perfil-detalhe-categorias-title" class="perfil-detalhe__subtitle">
          Categorias
        </h2>

        @if (perfil.categorias.length === 0) {
          <p class="perfil-detalhe__hint">Nenhuma categoria cadastrada para este perfil.</p>
        } @else {
          <ul class="perfil-detalhe__categoria-list">
            @for (categoria of perfil.categorias; track $index) {
              <li class="perfil-detalhe__categoria-item">
                <span
                  class="perfil-detalhe__swatch"
                  aria-hidden="true"
                  [style.background-color]="categoria.cor"
                ></span>
                <span class="perfil-detalhe__categoria-nome">{{ categoria.nomeCategoria }}</span>
                <span class="perfil-detalhe__categoria-valor">{{ categoria.valorPercentual }}%</span>
              </li>
            }
          </ul>
        }
      </section>

      <footer class="perfil-detalhe__footer">
        <!-- <button
          type="button"
          class="perfil-detalhe__btn-secondary"
          data-testid="perfil-detalhe-voltar-rodape"
          (click)="voltar()"
        >
          Voltar
        </button> -->
        <button
          type="button"
          class="btn-primary perfil-detalhe__btn"
          data-testid="perfil-detalhe-editar"
          (click)="editar()"
        >
          Editar Perfil
        </button>
      </footer>
    </section>
  }
</div>
